// extracted by mini-css-extract-plugin
export default {"errorMessage":"MySelect39_errorMessage__1ppne","select":"MySelect39_select__Ezzpr"};